import { Link, useLocation } from "react-router-dom";

import Button from "@/lib/components/ui/Button";

export const ProfileButton = (): JSX.Element => {
  const { pathname } = useLocation();
  const isNotHomePage = pathname !== "/";

  return (
    <Link to="/user">
      <Button
        iconName="user"
        variant={isNotHomePage ? "secondary" : "inverted"}
        className="px-[12px]"
      />
    </Link>
  );
};
